import { useLanguage } from "@/context/LanguageContext";
import { copy } from "@/content";

export const Marquee = () => {
  const { lang } = useLanguage();
  const text = copy[lang].marquee;

  return (
    <div className="overflow-hidden border-b border-white/10 bg-acid py-4" data-testid="marquee-strip">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((n) => (
          <span key={n} className="font-tty text-sm font-semibold uppercase tracking-[0.3em] text-black">
            {text.repeat(4)}
          </span>
        ))}
      </div>
    </div>
  );
};
